<!-- 招生订单记录--查看 -->
<template>
  <ZMainPage type="card">
    <div class="z-box-bg mb-2">
      <LineWrapper list  column="3" label-width="160rem" label-align="right">
        <LineItem v-for="item in labelConfig" :key="item.label" :label="item.label" :value="item.value"></LineItem>
      </LineWrapper>
    </div>
    <el-button @click="$router.back();">返回</el-button>
  </ZMainPage>
</template>

<script>
import LineWrapper from '@/components/common/LineWrapper'
import LineItem from '@/components/common/LineItem'
export default {
  _config: {"route": {"path": "details", "meta": {"title": "查看"}}},
  components: { LineWrapper, LineItem },
  data() {
    return {
      labelConfig: []
    }
  },
  mounted() {
    this.$_register.get('/api/recruit/order/get-order-detail', {params: {order_id: this.$route.query.id}}).then(res => {
      let data = res.data.data
      let v1 = data.goods_pack_name, v2 = data.pack_type_name
      if (['复读生正式报名', '转学生正式报名'].includes(data.order_type)) {
        v1 = '-'
        v2 = '-'
      }
      this.labelConfig = [
        {label: '商品订单号', value: data.order_number},
        {label: '订单类型', value: data.order_type},
        {label: '订单状态', value: data.pay_status},
        {label: '购买服务名称/收费项名称', value: v1},
        {label: '套餐类型', value: v2},
        {label: '报名学校', value: data.school_name},
        {label: '报名年级', value: data.grade_name},
        {label: '实际就读校区', value: data.study_school_name},
        {label: '报名学校顺序号', value: data.school_num},
        {label: '监护人姓名', value: data.customer_name},
        {label: '签约手机号', value: data.customer_phone},
        {label: '学生姓名', value: data.student_name},
        {label: '实际应缴金额', value: data.money_answer_actual_total / 100},
        {label: '实际支付金额', value: data.money_actual / 100},
        {label: '支付方式', value: data.pay_mode},
        {label: '合同名称', value: data.purchase_contract_name},
        {label: '合同编号', value: data.purchase_contract_num},
        {label: '报名时间', value: data.sign_time},
        {label: '当前客户归属人', value: data.teacher_name},
        {label: '支付订单号', value: data.pay_ids},
        {label: '支付成功时间', value: data.time_pay},
      ]
    })
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.card {
  padding: 50rem 0 1rem 60rem;
  background: #fff;
}
</style>
